/*
  TUFF TOOL BAGS — shared Add to cart for ttb-* sections.
  window.ttbCart.add(form, opener) posts a product form to /cart/add.js and then does what Symmetry 8's own
  product form does: the header (cart count) and cart drawer re-render from the same request, then it follows the
  theme's "after add to cart" setting (drawer, notification or cart page) and fires on:cart:add.
  Any form with data-ttb-quick-add (product cards) uses it automatically.
  Sections load this file with defer; loading it more than once is harmless.
*/
(function () {
  if (window.ttbCart) return;

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const settings = () => (window.theme && window.theme.settings) || {};

  // Symmetry's header and cart drawer, which re-render from the add-to-cart response.
  function cartSections() {
    return ['page-header', 'cart-drawer'].map((tag) => document.querySelector(tag))
      .filter((el) => el && el.dataset.sectionId && typeof el.updateFromCartChange === 'function');
  }

  async function add(form, opener) {
    const formData = new FormData(form);
    const sections = cartSections();
    if (sections.length) {
      formData.append('sections', sections.map((el) => el.dataset.sectionId).join(','));
      formData.append('sections_url', window.location.pathname);
    }

    const response = await fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    });
    const data = await response.json();
    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Sorry, that could not be added to your cart.');
    }

    after(data, opener || form, sections);
    return data;
  }

  function after(data, opener, sections) {
    const after = settings().afterAddToCart;
    const drawer = document.querySelector('.js-cart-drawer');
    const notification = document.getElementById('AddedNotification');

    // On the cart page itself, refresh the cart like Symmetry does
    if (document.querySelector('.template-cart')) {
      const cartForm = document.querySelector('cart-form');
      if (cartForm && typeof cartForm.refresh === 'function') cartForm.refresh();
      else window.location.reload();
      return;
    }

    // "Go to cart page", no JS cart, or the drawer/notification isn't on the page
    if (after === 'notification' ? !notification : (after !== 'drawer' || !drawer)) {
      window.location.href = root() + 'cart';
      return;
    }

    const fresh = data.sections || {};
    if (sections.length && sections.every((el) => fresh[el.dataset.sectionId])) {
      sections.forEach((el) => el.updateFromCartChange(fresh[el.dataset.sectionId]));
    } else {
      opener.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    }

    if (after === 'notification') {
      const note = notification.content.firstElementChild.cloneNode(true);
      note.dataset.productTitle = data.product_title;
      (document.querySelector('.pageheader--sticky') || document.body).appendChild(note);
    } else if (typeof drawer.open === 'function') {
      drawer.open(opener);
    } else {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: opener } }));
    }

    opener.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: data.variant_id } }));
  }

  // Swap a button's label for a moment, e.g. "Added".
  function flash(button, text, ms) {
    const label = button.querySelector('[data-ttb-label]');
    if (!label || !text) return;
    if (!button.dataset.ttbLabel) button.dataset.ttbLabel = label.textContent;
    label.textContent = text;
    clearTimeout(button.ttbTimer);
    button.ttbTimer = setTimeout(() => {
      label.textContent = button.dataset.ttbLabel;
      delete button.dataset.ttbLabel;
    }, ms || 2000);
  }

  // Product cards: <form data-ttb-quick-add> with a hidden variant id.
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest && event.target.closest('form[data-ttb-quick-add]');
    if (!form || settings().afterAddToCart === 'no-js') return;
    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    const error = form.querySelector('[role="alert"]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;

    try {
      await add(form, button);
      flash(button, button.dataset.addedLabel);
    } catch (err) {
      if (error) {
        error.textContent = err.message;
        error.hidden = false;
      }
    } finally {
      button.removeAttribute('aria-busy');
    }
  });

  window.ttbCart = { add: add, flash: flash, root: root };
})();
